import React, { useCallback, useEffect } from 'react'
import styled from 'styled-components'
import path from 'routes/path'
import AccountTemplate from 'components/templates/AccountTemplate'
import { Input } from 'antd'
import FormErrorMessage from 'components/atoms/FormErrorMessage'
import Colors from 'styles/colors'

/**
 * @type {React.FC<{
 *  isLoading: boolean,
 *  isSend: boolean
 *  errorMessages: string[]
 *  updatePassword: (args: {
 *    password: string,
 *    passwordConfirmation: string,
 *  }) => Promise<void>
 * } & any>}
 */
const PasswordResetEdit = ({
  isLoading,
  isSend,
  errorMessages,
  updatePassword,
  ...props
}) => {
  const handleSubmit = useCallback(e => {
    e.preventDefault()
    const password = e.target.password.value
    const passwordConfirmation = e.target.passwordConfirmation.value

    updatePassword({ password, passwordConfirmation })
  }, [])

  useEffect(() => {
    if (isSend) {
      window.scrollTo(0, 0)
    }
  }, [isSend])

  return (
    <AccountTemplate
      title={i18n.t('server.account.password_reset.title')}
      description={i18n.t('server.account.password_reset.description')}
      bodyClassName="body-home__index"
      isNoIndex
      {...props}
    >
      <div className="page__even lp-page__padding">
        <div className="page__col1">
          <div className="signup-head">
            <h1 className="page-title">{i18n.t('page.account.l_00025')}</h1>
          </div>

          <div className="signup-box">
            <div className="row">
              <div className="col-xs-12">
                {isSend ? (
                  <SendMessage />
                ) : (
                  <div className="signup-box__wrapper-form">
                    <p className="signup-box__notes ta-c mb10">
                      新しいパスワードを入力してください。
                    </p>
                    <div className="row">
                      <form onSubmit={handleSubmit}>
                        <div className="col-sm-12">
                          <PasswordWrapper>
                            <InputComponent
                              className="w100pa"
                              id="password"
                              name="password"
                              type="password"
                              placeholder="新しいパスワード"
                            />

                            <InputComponent
                              className="w100pa"
                              id="passwordConfirmation"
                              name="passwordConfirmation"
                              type="password"
                              placeholder="新しいパスワード（確認）"
                            />
                          </PasswordWrapper>
                          {errorMessages.map((message, index) => (
                            <FormErrorMessage key={index}>
                              {message}
                            </FormErrorMessage>
                          ))}
                        </div>
                        <div className="col-sm-12 ta-c mt20">
                          <input
                            type="submit"
                            name="commit"
                            value={'パスワードを再設定する'}
                            disabled={isLoading}
                            className="button-blue mt20 pt15 pb15 w200 sm-w100"
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AccountTemplate>
  )
}

export default PasswordResetEdit

const SendMessage = () => (
  <div className="signup-box__wrapper">
    <p className="signup-box__notes ta-c">パスワードを再設定しました。</p>
    <p className="signup-box__notes ta-c mt15">
      <a href={path.login()}>ログインページ</a>からログインしてください。
    </p>
  </div>
)

const PasswordWrapper = styled.div`
  display: grid;
  margin: 0 auto;
  row-gap: 16px;
  margin-top: 10px;
`

const InputComponent = styled(Input)`
  height: 40px;

  &.ant-input {
    border-radius: 6px;
    border-color: ${Colors.mono.gray40};
    font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
      'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
      'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
      'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    font-size: 14px;
    &::-webkit-input-placeholder {
      color: ${Colors.mono.gray40};
    }
    &:hover {
      border-color: ${Colors.brand.primary.main};
    }
    &.ant-input-disabled {
      &:hover {
        border-color: #e6d8d8;
      }
    }
    &:focus {
      border-color: ${Colors.brand.primary.main};
      box-shadow: none;
    }
  }
  &.ant-input-affix-wrapper {
    .ant-input {
      height: 40px;
      font-family: 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3',
        'ヒラギノ角ゴ StdN', 'Hiragino Kaku Gothic StdN', 'メイリオ', Meiryo,
        'ヒラギノ角ゴシック', 'Hiragino Sans', 'Verdana', 'Osaka',
        'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
      font-size: 14px;
      &::-webkit-input-placeholder {
        color: ${Colors.mono.gray40};
      }
      &:hover {
        border-color: ${Colors.brand.primary.main};
      }
      &.ant-input-disabled {
        &:hover {
          border-color: #e6d8d8;
        }
      }
      &:focus {
        border-color: ${Colors.brand.primary.main};
        box-shadow: none;
      }
    }
    :hover .ant-input:not(.ant-input-disabled) {
      border-color: ${Colors.brand.primary.main};
    }
  }
`
